import React from "react";
import "../../sass/components/card.scss";

const Card = ({ title, value, icon, color = "#0a66c2", description }) => {
  return (
    <div className="dashboard-card" style={{ borderLeft: `5px solid ${color}` }}>
      <div className="card-icon" style={{ backgroundColor: `${color}22` }}>
        {icon}
      </div>
      <div className="card-content">
        <span className="card-title">{title}</span>
        <span className="card-value">{value}</span>
        {description && <span className="card-description">{description}</span>}
      </div>
    </div>
  );
};

export default Card;
